import { HTTP } from '@/common/utils/http';
import { mapBodyParams } from '@/common/utils/mapBodyParams';
import { Stripe } from '@/constants/stripe';

export const BillingInfoService = {
    createStripeTokenForCard(form) {
        return Stripe.createToken(
            form.cardNumber,
            form.cardExpiry,
            form.cardCvc, {
                name: form.name,
                address_zip: form.zip,
                card_holder_type: 'individual'
            });
    },

    createSchoolBillingOption(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/billing`, mapBodyParams(form));
    },

    getSchoolBillingInfo(schoolId) {
        return HTTP.get(`schools/${schoolId}/billing`);
    },

    getSchoolBillingOption(schoolId, optionId) {
        return HTTP.get(`schools/${schoolId}/billing/${optionId}`);
    },

    editSchoolBillingOption(schoolId, optionId, form) {
        return HTTP.patch(`schools/${schoolId}/billing/${optionId}`, form);
    },

    deleteBillingOption(schoolId, optionId) {
        return HTTP.delete(`schools/${schoolId}/billing/${optionId}`);
    },

    getInvoices(schoolId) {
        return HTTP.get(`/schools/${schoolId}/billing/invoices`);
    },

    getInvoicePdfDownloadLink(schoolId, invoiceId) {
        return HTTP.get(`schools/${schoolId}/invoices/${invoiceId}/invoice-pdf`)
    }
};



// WEBPACK FOOTER //
// ./src/common/services/settings/billing-info.service.js